<div class="card hover-show w-100 overflow-auto h-100 d-flex flex-column position-relative" >
    <div class="card-body flex-grow-1 d-flex flex-column">
        <button *ngIf="appContext.isAdminOrIntermediary()" type="button" class="btn btn-icon position-absolute start-0 top-0 me-2 mt-2 to-show"
                role="button" aria-expanded="false" (click)="openMoveContractModal(contract)" data-bs-toggle="tooltip"
                data-bs-placement="top" title="Change Contract Owner">
            <i class="bi bi-arrow-left-right"></i>
        </button>
        <div class="text-center mb-3 pointer notranslate" (click)="navigateToContract()">
            <h2 class="card-title">
                <app-connection-image [connectionType]="contract.contract.contractData.connectionType"></app-connection-image>
                {{ contract.contract.contractData.name || "" }}
            </h2>
            <h5 class="text-muted">
                {{ contract.organisation.info ? contract.organisation.info.name : "" }}
            </h5>
        </div>
        <hr class="card-divider mb-0">
        <div class="list-group-flush mb-n3 list-group flex-grow-1">
            <div *ngFor="let period of contract.contract.periods; trackBy: trackByForRecord"
                 class="list-group-item py-3">
                <div class="row">
                    <div class="col-auto">
                        <i class="bi bi-calendar"></i>
                    </div>
                    <div class="col">
                        <small class="text-muted">
                            <app-contract-range [dateRange]="period.data.dateRange" [isReadOnly]="true"></app-contract-range>
                        </small>
                    </div>
                    <div class="col-auto my-3 ms-2" *ngIf="appContext.isAdminOrIntermediary()">
                        <button type="button" class="btn position-absolute top-0 end-0 to-show"
                                style="right: 24px !important;" role="button" aria-expanded="false" (click)="openContractPeriodModal(period)">
                            <i class="bi bi-pencil"></i>
                        </button>
                    </div>
                    <div class="col-auto my-3">
                        <app-confirmation-toggle *ngIf="appContext.isAdminOrIntermediary()">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h3 class="modal-title">Remove period</h3>
                                    <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button>
                                </div>
                                <div class="modal-body">
                                    <p>Are you sure you want to remove this contract period?</p>
                                </div>
                                <div class="modal-footer justify-content-between">
                                    <a type="button" class="btn btn-secondary"
                                       data-bs-dismiss="modal">Cancel</a>
                                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                                            (click)="deleteContractPeriod(period)">
                                        Remove period
                                    </button>
                                </div>
                            </div>

                            <button type="button" class="btn position-absolute top-0 end-0 to-show"
                                    role="button" aria-expanded="false">
                                <i class="bi bi-trash"></i>
                            </button>
                        </app-confirmation-toggle>
                    </div>
                </div>
            </div>
            <div *ngIf="appContext.isAdminOrIntermediary()" class="list-group-item py-3 pointer hover-underline mt-auto"
                 (click)="addNewContractPeriod()">
                <div class="row">
                    <div class="col-auto">
                        <i class="bi me-2 bi-plus-circle"></i>
                    </div>
                    <div class="col text-truncate"><small>Add period</small></div>
                </div>
            </div>
        </div>
    </div>
</div>